import { P2GBox, P2GGrid, P2GSticky } from '@parcel2go/core-ui';
import { DashDateSelection } from '../../dash/DashDateSelection';
import CsvExport from './CsvExport';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  period: string;
  selected: string;
  setPeriod: (period: string) => void;
  children?: React.ReactNode;
}

const ListyFilterBarDesktop: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.MYORDERS);
  return (
    <P2GSticky align="top" backgroundColor="transparent">
      <P2GBox pt={1} pb={1} sx={(t) => ({ backgroundColor: t.palette.grey.A100 })}>
        <P2GGrid container gap={2} alignItems="center" wrap="nowrap">
          {props.children && (
            <P2GGrid item flexShrink={1}>
              {props.children}
            </P2GGrid>
          )}
          <P2GGrid item flexGrow={1}></P2GGrid>
          <P2GGrid item flexShrink={1}>
            <DashDateSelection
              period={props.period}
              setPeriod={props.setPeriod}
              label={t('MY_ORDERS_DATE_RATE_LABEL', 'Date Range')}
            />
          </P2GGrid>
          <P2GGrid item flexShrink={1}>
            <CsvExport period={props.period} selected={props.selected} />
          </P2GGrid>
        </P2GGrid>
      </P2GBox>
    </P2GSticky>
  );
};

export default ListyFilterBarDesktop;
